<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 电脑导航 -->
    <!--    <div class="header-nav hidden-xs">-->
    <div class="container">
      <div class="header-nav">
        <!-- 导航logo -->
        <div class="header-nav-logo">
          <img src="../assets/img/header/logo.png" alt="logo">
        </div>
        <!-- 导航内容 -->
        <ul class="header-nav-wrapper">
          <li v-for="(item,index) in navList" :key="index" :class="index === navIndex ? 'active' : ''" @click="navClick(index, item.name)">
            <router-link :to="item.path">
              {{ item.name }}
              <span v-if="item.children" class="glyphicon glyphicon-menu-down"></span>
            </router-link>
            <dl v-if="item.children">
              <dt v-for="(i, n) in item.children" :key="n" :class="i.path === menuPath ? 'child-active' : ''">
                <router-link :to="i.path">{{ i.name }}</router-link>
              </dt>
            </dl>
          </li>
        </ul>
      </div>
    </div>
    <!--    &lt;!&ndash; 手机导航 &ndash;&gt;-->
    <!--    <div class="header-nav-m container-fuild visible-xs">-->
    <!--      <div class="header-nav-m-logo">-->
    <!--        <img class="center-block" src="../assets/img/header/logo.png" alt="logo">-->
    <!--      </div>-->
    <!--      &lt;!&ndash; 导航栏 &ndash;&gt;-->
    <!--      <div class="header-nav-m-menu text-center">-->
    <!--        {{ menuName }}-->
    <!--        <div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick">-->
    <!--          <span :class="menuClass"></span>-->
    <!--        </div>-->
    <!--        &lt;!&ndash; 导航内容 &ndash;&gt;-->
    <!--        <ul id="menu" class="header-nav-m-wrapper collapse">-->
    <!--          <li v-for="(item,index) in navList" :key="index" :class="index === navIndex ? 'active' : ''" @click="navClick(index, item.name)"-->
    <!--              data-toggle="collapse" data-target="#menu">-->
    <!--            <router-link :to="item.path">-->
    <!--              {{ item.name }}-->
    <!--              <i class="underline"></i>-->
    <!--            </router-link>-->
    <!--          </li>-->
    <!--        </ul>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? parseInt(sessionStorage.getItem('navIndex')) : 0,
      menuName: "官网首页",
      menuPath: '/',
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "官网首页",
          path: "/home",
          index: 0
        },
        {
          name: "走进水成",
          path: "/about/introduction",
          index: 1,
          children: [
            {
              name: "企业简介",
              path: "/about/introduction"
            },
            {
              name: "发展历程",
              path: "/about/progress"
            },
            {
              name: "企业文化",
              path: "/about/culture"
            }
          ]
        },
        {
          name: "产品中心",
          path: "/product/SK",
          index: 2,
          children: [
            {
              name: "SK系列",
              path: "/product/SK"
            },
            {
              name: "V系列",
              path: "/product/V"
            },
            {
              name: "X系列",
              path: "/product/X"
            },
            {
              name: "M系列",
              path: "/product/M"
            },
            {
              name: "S系列",
              path: "/product/S"
            },
            {
              name: "开水器",
              path: "/product/KSQ"
            },
            {
              name: "水星1号",
              path: "/product/SX"
            }
          ]
        },
        {
          name: "品牌新闻",
          path: "/news",
          index: 3
        },
        {
          name: "水之道",
          path: "/water",
          index: 4
        },
        {
          name: "加入我们",
          path: "/join/apply",
          index: 5,
          children: [
            {
              name: "代理商申请",
              path: "/join/apply"
            },
            {
              name: "企业招聘",
              path: "/join/work"
            }
          ]
        }
      ]
    };
  },
  watch: {
    '$route'(to, from) {
      this.menuPath = to.path;
      let thisNav = this.navList.find(item =>{
        return item.path === to.path
      });
      if(thisNav){
        this.navIndex = thisNav.index;
        sessionStorage.setItem('navIndex', thisNav.index);
        this.menuName = thisNav.name;
      }
    }
  },
  methods: {
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex', index);
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass === "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #FFFFFF;
  transition: all ease 0.6s;
}

/* 导航栏 */
#header .header-nav {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 100px;
  height: 100%;
  float: left;
}

/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 165px;
  height: 100%;
}

#header .header-nav .header-nav-wrapper {
  line-height: 120px;
  float: right;
  margin: 0;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin-left: 30px;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  font-family: "Noto Sans SC regular", monospace;
  color: #4A4A4A;
  font-size: 20px;
  font-weight: initial;
  padding: 5px 10px;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #6E6EF0;
  text-decoration: none;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #6E6EF0;
  text-decoration: none;
  background: #FFFFFF;
  border-radius: 20px;
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 130px;
  top: 80%;
  left: 0;
  z-index: 999999;
  background: #e1dffd;
  border-radius: 10px;
  text-align: center;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 110px;
  padding: 5px;
  margin: 10px;
  border-radius: 25px;
  background: #ffffff;
}

#header .header-nav .header-nav-wrapper > li > dl > dt a {
  color: rgb(100, 100, 240);
  width: 100px;
  display: block;
}


#header .header-nav .header-nav-wrapper > li > dl > dt.child-active {
  background: rgb(100, 100, 240);
}

#header .header-nav .header-nav-wrapper > li > dl > dt.child-active a {
  color: #FFFFFF;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/

#header .header-nav .header-nav-wrapper > li > dl > dt > a {
  text-decoration: none;
}

#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}

#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: rgb(100, 100, 240);
}

#header .header-nav .header-nav-wrapper > li > dl > dt:hover a {
  color: #FFFFFF;
}

@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue